var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"header-menu"},[_c('navBar',{model:{value:(_vm.objSave),callback:function ($$v) {_vm.objSave=$$v},expression:"objSave"}})],1),_c('div',{staticClass:"page-content"})])}
var staticRenderFns = []

export { render, staticRenderFns }